import { convertThenFormat } from "../../common-data/Converts";

export const getCardLabel = (key) => {
  switch (key) {
    case "pending_leads":
      return "Pending Followup";

    default:
      return key.replace(/_/g, " ");
  }
};

export const getCardValue = (key, value, amount) => {
  return `₹${convertThenFormat(amount || 0)} (${convertThenFormat(
    value || 0
  )})`;
};
